import { InterconsultaCreate } from "./InterconsultaCreate";
import { NotificacionCreate } from "./NotificacionCreate";
import { useLoaderData, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Select from "react-select";

import { FormatDate } from "../components/documentacion/FormatDate";

import * as APITRATAMIENTO from "../services/tratamientos";
import * as APIESPECIALISTAS from "../services/especialistas";
import * as APIPACIENTES from "../services/pacientes";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return APIPACIENTES.getPacienteByID(params.pacienteId);
}

export function InterconsultaNew(props) {
  const paciente = useLoaderData();
  console.log(props)

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  const [loading, setLoading] = useState(false);
  const [isCreatingButton, setIsCreatingButton] = useState(false);

  const [interDestAll, setInterDestAll] = useState(""); // Todos los posibles receptores
  const [interDestOptions, setInterDestOptions] = useState(""); // Todos los posibles receptores

  const [interResp, setInterResp] = useState(props.especialistaFullName);
  const [metaFecha, setInterFecha] = useState(todayDate);
  const [interAsu, setInterAsu] = useState("");
  const [interDestSelected, setInterDestSelected] = useState("");
  const [interDest, setInterDest] = useState("");
  const [interDestAllow, setInterDestAllow] = useState([props.especialistaId]);
  const [interObs, setInterObs] = useState("");
  // const [interFile, setInterFile] = useState("Ningún archivo adjunto");

  const [interNoti, setInterNoti] = useState("");
  const [pacienteName, setPacienteName] = useState(paciente.name);

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  // 0.1 Set interDest Initial
  useEffect(() => {
    const initialObject = {
      value: props.especialistaId,
      label: interResp
    };
    setInterDest(initialObject);
  }, [interResp]);

  // 0.5 Load Especialistas
  useEffect(() => {
    const loadEspecialistasAll = async () => {
      // Till the data is fetch using API
      // the Loading page will show.
      setLoading(true);

      // Await make wait until that
      // promise settles and return its result
      const response = await APIESPECIALISTAS.getAllEspecialistasInTreatAndPsicoHospAndAdmins(tratamientoId);

      // After fetching data stored it in posts state.
      setInterDestAll(response);

      // Closed the loading page
      setLoading(false);
    };

    // Call the function
    loadEspecialistasAll();
  }, [tratamientoId]);

  // 1. Clean Especialistas (remove Current from Options)
  useEffect(() => {
    // Si interDestAll no está vacío
    if (interDestAll.length > 0) {
      // Lista de valores a eliminar
      const valuesToRemove = [props.especialistaId];
  
      // Filtrar el arreglo para excluir los elementos con los valores dados
      const filteredInterDestOptions = interDestAll.filter(item => !valuesToRemove.includes(item.value));
  
      // Actualizar el estado con el nuevo arreglo filtrado
      setInterDestOptions(filteredInterDestOptions);
    }
  }, [interDestAll]);

  // 4.Create an array of Ids of selected Especialistas
  useEffect(() => {
    if (interDestSelected) {
      let initialObject = {
        value: props.especialistaId,
        label: interResp
      };
      let combinedArray = [initialObject, ...interDestSelected];
      setInterDest(combinedArray);
      let allSelectedId = interDestSelected.map((field) => field.value);
      let allowIds = allSelectedId.concat(props.especialistaId);
      setInterNoti(allSelectedId);
      setInterDestAllow(allowIds.toString());
    }
  }, [interDestSelected]);

  // function handleChange(event) {
  //   setInterFile(event.target.files[0].name);
  // }

  const submitInterconsulta = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      interResp,
      metaFecha,
      interAsu,
      interDest,
      interDestAllow,
      interObs,
      tratamientoId,
      pacienteId
    );
    try {
      // Crear interconsulta
      const val = await InterconsultaCreate(
        interResp,
        metaFecha,
        interAsu,
        interDest,
        interDestAllow,
        interObs,
        tratamientoId,
        pacienteId
      );

      // Iterar sobre cada ID en interNoti y crear una notificación para cada uno
      let notiUrl = `pacientes/${pacienteId}/${tratamientoId}/interconsultas/${val.id}`;
      let cleanDate = FormatDate(todayDate);
      let notiText = `${cleanDate} - Nuevo mensaje en Interconsulta de Paciente: ${pacienteName}`;
      for (const id of interNoti) {
        await NotificacionCreate(
          id,
          metaFecha,
          notiText,
          notiUrl,
          false);
      }

      // Redirigir
      window.location.replace(`../interconsultas/${val.id}`);
    } catch (error) {
      console.error(error);
    } finally {
      setIsCreatingButton(false);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitInterconsulta}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='interResp'>
                Responsable
              </label>
              <div className='control'>
                <input
                  className='input'
                  id='interResp'
                  required
                  type='text'
                  value={interResp}
                  onChange={(e) => setInterResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='metaFecha'>Fecha</label>
              <div className='control'>
                <input
                  className='input'
                  id='metaFecha'
                  required
                  type='date'
                  value={metaFecha}
                  onChange={(e) => setInterFecha(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='interAsu'>Asunto</label>
              <div className='control'>
                <input
                  className='input'
                  id='interAsu'
                  required
                  type='text'
                  value={interAsu}
                  onChange={(e) => setInterAsu(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='interDest'>Destinatarios</label>
              <div className='control'>
                <Select
                  isMulti
                  required
                  id='interDest'
                  name='interDest'
                  options={interDestOptions}
                  className='basic-multi-select'
                  classNamePrefix='select'
                  isLoading={loading}
                  placeholder='Seleccionar destinatarios'
                  onChange={setInterDestSelected}
                />
              </div>
            </div>
          </div>
          <div className='field'>
            <label htmlFor='interObs'>Mensaje</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='interObs'
                id='interObs'
                value={interObs}
                onChange={(e) => setInterObs(e.target.value)}
              ></textarea>
            </div>
          </div>
          {/* <div className="field file has-name">
            <label htmlFor='interFile' className="file-label">
              <input
              className="file-input"
              type="file"
              name="interFile"
              onChange={handleChange}
              />
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-upload"></i>
                </span>
                <span className="file-label">
                  Seleccionar archivo…
                </span>
              </span>
              <span className="file-name">
              {interFile}
              </span>
            </label>
          </div> */}
        </form>
      </div>
      <div id='actions'>
        <button className='button is-link' disabled={isCreatingButton} form='formNewElement' type='submit'>
        {isCreatingButton ? <div className="spinner"></div> : 'Enviar'}
        </button>
      </div>
    </>
  );
}
